// extracted by mini-css-extract-plugin
module.exports = {"content":"Login_content__21R4P","row":"Login_row__35lmT","loginForm":"Login_loginForm__QtM7m"};